import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useDocuments } from '@terminal/react-query-hooks/documents/useDocumentsEntity';
import React from 'react';

import { useDocumentModal } from '../../document-modal/useDocumentModal';
import styles from './DocumentsRow.module.scss';

export interface DocumentsRowProps {
  id: string;
  name: string;
}

export const DocumentsRow = ({ id, name }: DocumentsRowProps) => {
  const { openModal } = useDocumentModal();
  const { data, isFetching } = useDocuments([id]);

  const document = data?.[0];

  const getContent = () => {
    if (isFetching) {
      return (
        <div className={styles.skeletonLoaderWrapper}>
          <SkeletonLoader
            areas={[
              {
                styles: {
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px',
                },
              },
            ]}
          />
        </div>
      );
    } else if (document) {
      return (
        <div className={styles.rowWrapper}>
          <img
            className={styles.pdfIcon}
            src="/app/static/images/icons/pdf.svg"
            alt=""
          />
          <div className={styles.flexColumn}>
            <span className={styles.titleLabel}>{`${name || document.name}.${
              document.type
            }`}</span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={styles.root} onClick={() => openModal(id)}>
      {getContent()}
    </div>
  );
};
